import { Experiments } from './utils';

export const shouldUseLoadingPerf = (userData: any, staticData: any) => {
  return !!staticData?.ENABLE_LOADING_PERF || !!userData?.experiments?.[Experiments.LoadingPerf];
};

export const shouldUseSeriesTagsPagination = (userData: any, staticData: any, showTagSeriesInBrowse: boolean) => {
  return !!showTagSeriesInBrowse && shouldUseLoadingPerf(userData, staticData);
};
